export const SET_EMPLOYEE = "SET_EMPLOYEE";

const action = {};

action.setEmployee = (payload) => {
  return {
    type: SET_EMPLOYEE,
    payload,
  };
};

export default action;
